module.exports = __webpack_public_path__ + "img/ico-loc.04c9114f.svg";